import { useState } from 'react'

import type { ReactElement } from 'react'
import type { DeviceType } from '~/types/device-type'

import Button from '~/components/Buttons/Button'
import { useRefreshIapMutation } from '~/queries/iap'
import { displayToast } from '~/utils/toast'

interface Props {
  appId?: string
  deviceType?: DeviceType
  onSynchronizeSuccess: VoidFunction
}

const getButtonLabelWithPlatform = (isSynchronizing: boolean, deviceType?: DeviceType) => {
  if (deviceType && deviceType === 'android') {
    return `${isSynchronizing ? 'Synchronizing' : 'Synchronize'} IAPs from Google Play`
  } else if (deviceType && deviceType === 'ios') {
    return `${isSynchronizing ? 'Synchronizing' : 'Synchronize'}  IAPs from App Store Connect`
  }

  return `${isSynchronizing ? 'Synchronizing' : 'Synchronize'}  IAPs from Store`
}

const SynchronizeButton = ({ appId, deviceType, onSynchronizeSuccess }: Props): ReactElement => {
  const [isSynchronizing, setIsSynchronizing] = useState(false)

  const { mutateAsync: refreshIapMutation } = useRefreshIapMutation()

  const onSyncClick = async () => {
    if (appId) {
      setIsSynchronizing(true)
      try {
        await refreshIapMutation(appId)
        displayToast('IAP successfully synchronized', 'success')
        onSynchronizeSuccess()
      } catch {
        displayToast('IAP could not be synchronized', 'error')
      } finally {
        setIsSynchronizing(false)
      }
    }
  }

  return (
    <Button disabled={isSynchronizing} onClick={onSyncClick}>
      {getButtonLabelWithPlatform(isSynchronizing, deviceType)}
      {isSynchronizing ? <div className="lds-dual-ring" /> : null}
    </Button>
  )
}

export default SynchronizeButton
